import { useEffect, useState } from "react";
import styled from "styled-components";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

function ScoreGraph({student}){
    const {readFirestoreOneDoc} = useFirestore();
    const {getBranchId} = useGetBranchId();
    const [scoreList, setScoreList] = useState([]);
    const date = new Date();
    const getScoreList = async() => {
        const score_list = [];
        const branch_id = await getBranchId();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();
        let i = 0;
        while(true){
            if(month === 0){
                year -= 1;
                month = 12;
            }
            if(i === 5){
                break;
            }
            const score = await readFirestoreOneDoc(`Score/Branch/${branch_id}/${year}/${month}`, student).then(res => {
                if(res.exists()){
                    return {month:month, score:res.data().score}
                }else{
                    return {month:month, score:0}
                }
            })
            score_list.push(score);
            month -= 1;
            i += 1;
        }
        setScoreList(score_list.reverse());
    }

    useEffect(() => {
        getScoreList();
    }, [])

    if(!scoreList.length){
        return null;
    }
    const diff = scoreList[scoreList.length - 1].score - scoreList[scoreList.length - 2].score;
    const setGraph = () => {
        return scoreList.map((item, index) => {
            return <BarWrap key={index + 1} height={`100%`}>
                <Score style={index + 1 === scoreList.length ? {color:"#DF0000"} : {}} score={100 - item.score}>{item.score}</Score>
                <Bar style={index + 1 === scoreList.length ? {backgroundColor:"#DF0000"} : {}} score={item.score}></Bar>
                <Label>{`${item.month}월`}</Label>
            </BarWrap>
        })
    }

    return(
        <Container >
            <Description>지난달보다 <Highlight>{`${diff}점 올랐어요`}</Highlight></Description>
            <Graph>
                {setGraph()}
            </Graph>
        </Container>   
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 24px;
    border-radius: 20px;
    height: 100%;
`

const Description = styled.div`
    color: #0F172A;
    font-size: 14px;
    font-weight: 600;
`

const Highlight = styled.span`
    color: #DF0000;
`

const Graph = styled.div`
    display: flex;
    gap: 10px;
    flex-grow: 1;
    align-items: end;
`

const BarWrap = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    gap: 6px;
    height: ${(props) => props.height};
    animation: slideUp 0.5s ease forwards;
`

const Bar = styled.div`
    width: 100%;
    border-radius: 10px 10px 0px 0px;
    background: #D9D9D9;
    flex-basis: ${(props) => props.score}%;
`
const Score = styled.span`
    color: #555;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: end;
    flex-basis: ${(props) => props.score}%;
`

const Label = styled.span`
    color: #6E6E6E;
    font-size: 12px;
    font-weight: 400;
`


export default ScoreGraph;